module.exports = __webpack_public_path__ + "img/cycle-2_a_alt.116350e0.png";